module.exports = __webpack_public_path__ + "img/challenge.5b438dbe.svg";